// Capture the URL hash BEFORE any other module (including the Supabase client,
// which auto-parses recovery / magic-link hashes via `detectSessionInUrl`) gets
// a chance to consume and strip it. The portal reset-password page reads from
// `window.__bfRecoveryHash` as a fallback so the recovery token survives the
// global client's initialization race. Safe no-op on any other URL.
if (typeof window !== 'undefined' && window.location.hash) {
  (window as unknown as { __bfRecoveryHash?: string }).__bfRecoveryHash =
    window.location.hash;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import App from './App';
import '../globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <Helmet defaultTitle="Beverage Federation - Marketplace" titleTemplate="%s | Beverage Federation" />
    <App />
  </HelmetProvider>
);
